var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualTaskProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C5.425 8 4.8875 8.0875 4.3875 8.2625C3.8875 8.4375 3.425 8.68333 3 9V10H9V9C8.575 8.68333 8.1125 8.4375 7.6125 8.2625C7.1125 8.0875 6.575 8 6 8ZM3 11C2.725 11 2.48967 10.9022 2.294 10.7065C2.09833 10.5108 2.00033 10.2753 2 10V2C2 1.725 2.098 1.48967 2.294 1.294C2.49 1.09833 2.72533 1.00033 3 1H9C9.275 1 9.5105 1.098 9.7065 1.294C9.9025 1.49 10.0003 1.72533 10 2V10C10 10.275 9.90217 10.5105 9.7065 10.7065C9.51083 10.9025 9.27533 11.0003 9 11H3ZM6 7C6.48333 7 6.89583 6.82917 7.2375 6.4875C7.57917 6.14583 7.75 5.73333 7.75 5.25C7.75 4.76667 7.57917 4.35417 7.2375 4.0125C6.89583 3.67083 6.48333 3.5 6 3.5C5.51667 3.5 5.10417 3.67083 4.7625 4.0125C4.42083 4.35417 4.25 4.76667 4.25 5.25C4.25 5.73333 4.42083 6.14583 4.7625 6.4875C5.10417 6.82917 5.51667 7 6 7Z",
    fill: "#403C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualTaskProfile);
export default __webpack_public_path__ + "static/media/manualTaskProfile.82cbcdb569083b95930c80e8e039c05d.svg";
export { ForwardRef as ReactComponent };